import { ElMessage, ElMessageBox,ElNotification } from "element-plus";
import { WebsiteUrl } from "../../../utils";
import Loading from "../../../utils/Loading"; //获取加载组件
import Auth from "../../../utils/auth";
import Sidentify from "../../../components/Sidentify";//引入验证码组件
import Api_Member from "../../../api/FrontEnd/Member";

export default {
	name: 'Login',
	components: {
		Sidentify
	},
	props:{
		onShow:{
			type:Boolean,
			default:false,
		}
	},
	data(){
		return{
			Visible:false,

			ImageLogoUrl:WebsiteUrl()+'/images/ModuleBoxTopBodyBodyLogo.png',

			CaptchaValue:this.GetIdentifyCode(),

			LoginForm:{},
			LoginRules:{
				Username:[
					{
						required:true,
						message:"请输入登录账号",
						trigger:"blur"
					},
				],
				Password:[
					{
						required:true,
						message:"请输入登录密码",
						trigger:"blur"
					},
				],
				Captcha:[
					{
						required:true,
						message:"请输入验证码",
						trigger:"blur"
					},
				],
			},
		}
	},
	methods:{
		onHide(){
			this.$emit("onHide",false);
			this.Visible = false;
		},
		Init(){
			this.LoginForm = {};
		},
		onRegister(){
			this.$emit("onRegister");
		},
		onResetPassword(){
			this.$emit("onResetPassword");
		},
		LoginSubmit(){
			this.$refs.LoginFormRef.validate(async (valid) => {
				// console.log(this.$refs.LoginFormRef);
				// console.log(this.$refs.LoginFormRef.validate());
				if(valid){
                    // if(this.LoginForm.Captcha !== this.CaptchaValue){
                    //     this.LoginForm.Password = '';
                    //     this.LoginForm.Captcha = '';
                    //     this.ResetCaptcha();
                    //     ElMessage.error("验证码有误，请重新输入");
                    //     return false;
                    // }

					this.ResetCaptcha();

					//获取接口返回值
					Loading.LoadingShow();
					let RequestData = this.LoginForm;
					let ReturnData = Api_Member.MemberCheckIn(RequestData);
					ReturnData.then(response => {
						// console.log(response);
						Loading.LoadingHide();
						let State = response['Data'][0].State;
						let Message = response['Data'][0].Message;
						if(State == 'Success'){
							let Data = JSON.parse(response['Data'][0].Data);
							// console.log(Data);
							//赋值Token
							Auth.setToken(response['Data'][0].Token);
							//赋值Info
							Auth.setInfo(response['Data'][0].Data);

							this.$emit("onLogin");

							this.onHide();
							// ElMessage.success(Message);

							ElNotification({
								type: 'success',
								title: "系统提示",
								message: "账号已登录",
								position: 'bottom-right',
								duration: 3000,
							})
						}else{
							this.LoginForm = {};
							ElMessage.error(Message);
						}
					})


					// console.log(this.LoginForm);
				}else{
					ElMessage.error("请根据提示完成填写");
				}
			});
		},

        GetIdentifyCode() {
            const characters = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
            const idLength = 5; // 字符串长度 这里生成30位的
            let randomCode = '';

            for (let i = 0; i < idLength; i++) {
                const randomIndex = Math.floor(Math.random() * characters.length);
                randomCode += characters.charAt(randomIndex);
            }

            return randomCode;
        },
        ResetCaptcha(){
            this.LoginForm.Captcha = '';
            this.CaptchaValue = this.GetIdentifyCode();
            this.$refs.Captcha.drawPic();
        },

	},
	mounted(){
		
	},
	watch:{
		onShow(Value){
			this.Visible = Value;
			this.Init();
		},


	},
	emits:{
		"onHide":null,
		"onLogin":null,
		"onRegister":null,
		"onResetPassword":null,
	}
}

